<template>
  <div v-shortkey="{'win':['ctrl', 'shift', 'f'], 'osx':['meta', 'shift', 'f']}"
      @shortkey="indent()">
    <code-editor
      class="my-editor"
      :spellcheck="false"
      :selector_displayed_by_default="true"
      width="100%"
      height="500px"
      font_size="14px"
      v-model="item.content"
      :languages="[['Twig', 'Twig']]"
    ></code-editor>
  </div>
</template>

<script>

import  { indent }  from 'indent.js';

export default {
  props: {
    item: { type: Object, default: () => ({}) },
  },
  mounted() {
    const el = document.getElementsByTagName("textarea");
    el[0].spellcheck = false;
  },
  data: () => ({
  }),
  methods: {
    indent() {
      this.item.content = indent.html(this.item.content)
    }
  },
};
</script>

<style>
/* required class */
.my-editor {
  /* we dont use `language-` classes anymore so thats why we need to add background and text color manually */
  background: #2d2d2d;
  color: #ccc;

  /* you must provide font-family font-size line-height. Example: */
  line-height: 1.5;
  letter-spacing: 0em !important;
  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  padding: 5px;
}

.my-editor .panel {
  display: none;
}
</style>